/* Lead contact details */
export default function LeadContactDetails({ lead }) {
  return (<div className="card h-100"><div className="card-body">
    <h6 className="mb-3">Contact details</h6>
    <div className="d-flex align-items-center gap-3 mb-3"><span className="avatar" style={{ width: 48, height: 48 }}>{lead.name[0]}</span><div><div className="fw-semibold">{lead.name}</div><small className="text-muted">{lead.id}</small></div></div>
    <div className="mb-1">✉️ <a href={`mailto:${lead.email}`}>{lead.email}</a></div>
    <div>📞 {lead.phone ? <a href={`tel:${lead.phone}`}>{lead.phone}</a> : <span className="text-muted">No phone given</span>}</div>
    {lead.company && <div className="mt-1">🏢 {lead.company}</div>}
    {lead.message && <div className="mt-2 small"><span className="text-muted">Message:</span> {lead.message}</div>}</div></div>)
}
